export const advancedBtoa = (text: string) => {
	const utf8Bytes = new TextEncoder().encode(text);
	return btoa(String.fromCharCode(...utf8Bytes));
};
